const REQUEST_CHAT = {
  INTERNAL: 'internal',
  NETWORK: 'network',
};
const LABS = {
  labsOrder: 'labsOrder',
};
const REIMBURSEMENT = {
  reimbursement: 'reimbursement',
};
const PHARMACY = {
  pharmacyOrder: 'pharmacyOrder',
};

const config = {
  REQUEST_CHAT,
  LABS,
  REIMBURSEMENT,
  PHARMACY
};

export default config;
